import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'

import { BaseDialog, Stepper } from 'shared'
import QuestionStep from './QuestionStep'
import ConfirmationStep from './ConfirmationStep'

import { BaseModalComponentType } from '../types'
import { withModal } from 'utils/providers/ModalProvider'
import modals from 'constants/modals'

const useStyles = makeStyles(() => {
  return {
    dialog: {
      '& .base-dialog-header h2': {
        maxWidth: '380px',
      },
    },
  }
})

const DeleteAccountModal = ({ closeModal, isOpen }: BaseModalComponentType) => {
  const classes = useStyles()
  const [title, setTitle] = useState(
    'Are you sure you want to delete your account'
  )

  const onStepChange = (index: number) => {
    if (index === 0) {
      return setTitle('Are you sure you want to delete your account')
    }
    return setTitle('We hate to see you go. Why are you deleting your account?')
  }

  return (
    <BaseDialog
      className={classes.dialog}
      open={isOpen}
      onClose={closeModal}
      title={title}
    >
      <Stepper onStepChange={onStepChange}>
        <ConfirmationStep closeModal={closeModal} />
        <QuestionStep closeModal={closeModal} />
      </Stepper>
    </BaseDialog>
  )
}

export default withModal(modals.deleteAccountModal)(DeleteAccountModal)
